import { addMonths } from 'date-fns';

export function setMessages(state, payload) {
  state.messages = payload;
}

export function clearMessages(state) {
  state.messages = undefined;
}

export function setGenericDocuments(state, payload) {
  state.genericDocuments = payload;
}

export function clearGenericDocuments(state) {
  state.genericDocuments = [];
}

export function setMessageToRead(state, payload) {
  state.messages.forEach((message) => {
    if (message.documentID === payload && message.hasBeenRead === false) {
      message.hasBeenRead = true;
      state.unreadDocuments--;

      if (message.publicationDate >= addMonths(new Date(), -6)) {
        state.unreadDocumentsLast6Months--;
      }
    }
  });
}

export function setIsLoadingMessages(state, payload) {
  state.isLoadingMessages = payload;
}

export function clearIsLoadingMessages(state) {
  state.isLoadingMessages = false;
}

export function setIsLoadingGenericDocuments(state, payload) {
  state.isLoadingGenericDocuments = payload;
}

export function clearIsLoadingGenericDocuments(state) {
  state.isLoadingGenericDocuments = false;
}

export function setUnreadDocuments(state, payload) {
  state.unreadDocuments = payload;
}

export function clearUnreadDocuments(state) {
  state.unreadDocuments = undefined;
  state.unreadDocumentsLast6Months = undefined;
}

export function setUnreadDocumentsLast6Months(state, payload) {
  state.unreadDocumentsLast6Months = payload;
  state.hasUnreadDocumentsLast6Months = state.hasUnreadDocumentsLast6Months || payload > 0;
}
